import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { ExternalLink, HelpCircle } from 'lucide-react';

interface HelpLinkItem {
  label: string;
  href: string;
}

interface HelpDisabledItem {
  label: string;
}

const HELP_LINKS: HelpLinkItem[] = [
  { label: 'Brand Guidelines', href: 'https://brandguide.bosch.com/' },
  {
    label: 'Documentation',
    href: 'https://inside-docupedia.bosch.com/confluence/display/PTITDIGITAL/11.+JENNY+-+Gen+AI%3A+content+creation+project',
  },
  { label: 'Teams Channel', href: 'https://teams.microsoft.com/jenny-channel' },
];

const HELP_DISABLED: HelpDisabledItem[] = [{ label: 'Open Ticket' }, { label: 'Give Feedback' }];

export function HelpMenu() {
  return (
    <TooltipProvider>
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            aria-label="Help"
            className="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded border-none bg-transparent text-[var(--text-primary)] hover:bg-[var(--bg-secondary)] transition-colors"
          >
            <HelpCircle size={20} />
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" sideOffset={8} className="w-60 p-0">
          <nav aria-label="Help and resources">
            <ul className="m-0 list-none py-1">
              {HELP_LINKS.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-between px-3 py-2 text-[length:var(--text-sm)] text-[var(--text-link)] no-underline hover:bg-[var(--bg-secondary)] transition-colors"
                  >
                    {item.label}
                    <ExternalLink size={14} />
                  </a>
                </li>
              ))}
            </ul>
            <div role="separator" className="mx-3 h-px bg-[var(--border-default)]" />
            <ul className="m-0 list-none py-1">
              {HELP_DISABLED.map((item) => (
                <li key={item.label}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span
                        aria-disabled="true"
                        className="flex cursor-default items-center justify-between px-3 py-2 text-[length:var(--text-sm)] text-[var(--text-disabled)]"
                      >
                        {item.label}
                        <span className="text-[length:var(--text-xs)] opacity-70">soon</span>
                      </span>
                    </TooltipTrigger>
                    <TooltipContent side="left">Coming soon</TooltipContent>
                  </Tooltip>
                </li>
              ))}
            </ul>
          </nav>
        </PopoverContent>
      </Popover>
    </TooltipProvider>
  );
}
